import {BewerbRunde} from "@/services/data/meisterschaften/bewerbRunde";
import FirebaseWrite from "@/services/database/firebaseWrite";
import {RESULT_STATUS} from "@/services/data/meisterschaften/bewerb_constants";

export function sortBewerbRundeTabTeams(teamsMap, returnMap){
    const teamList = Object.values(teamsMap).map( (team) => ({
        ...team, statusSort: RESULT_STATUS.find( (status) => status.value === team.results.status )?.sort??4
    }))
    let sortedList = teamList.sort( (a, b) => {
        if ( a.statusSort === b.statusSort ) {
            if (a.results.gesamt === b.results.gesamt) {
                if (a.results.abraeumen === b.results.abraeumen) {
                    if (a.results.fehlwuerfe === b.results.fehlwuerfe) {
                        return a.results.status < b.results.status;
                    }
                    return a.results.fehlwuerfe - b.results.fehlwuerfe;
                }
                return b.results.abraeumen - a.results.abraeumen;
            }
            return b.results.gesamt - a.results.gesamt;
        }
        return a.statusSort - b.statusSort;
    })
    let fixed = null
    for ( let i = 1; i <= sortedList.length; i++ ) {
        const current = sortedList[i-1]
        const previous = sortedList[i-2]
        current.results.position = !current.results.status?1000:fixed??i
        if ( !current.results.gesamt && !fixed ) fixed = i
        current.results.losEntscheid = false
        if ( previous && previous.results.gesamt > 0 && current.results.gesamt > 0 &&
            previous.results.gesamt === current.results.gesamt &&
            previous.results.abraeumen === current.results.abraeumen &&
            previous.results.fehlwuerfe === current.results.fehlwuerfe ) {
            current.results.position = previous.results.position
            current.results.losEntscheid = true
            previous.results.losEntscheid = true
        }
    }
    const sortedListLos = sortedList.map(
        (team) => ({...team, results: {...team.results, position: team.results.positionLos?
                    team.results.positionLos:team.results.position}})
    ).sort( (a, b) => { return b.results.position - a.results.position;})
    if ( !returnMap ) {
        return sortedListLos
    } else {
        const sortedMap = {}
        sortedListLos.forEach( (team) => {
            const teamTemp = JSON.parse(JSON.stringify(team))
            delete teamTemp.statusSort
            sortedMap[team.id] = teamTemp
        })
        return sortedMap
    }
}

export class BewerbRundeTab extends BewerbRunde {
    constructor(bewerbRunde, id, bewerbSettings) {
        super(bewerbRunde, id, bewerbSettings);
        this.teams = bewerbRunde?.teams??{};
    }

    getTeamList() {
        return Object.values(this.teams).sort((a, b) => a.results.position > b.results.position ? 1 : -1);
    }

    getTeamGroups(groupSize) {
        const teamList = this.getTeamList()
        const teamGroups = []
        for ( let i = 0; i < teamList.length; i += groupSize ) {
            teamGroups.push(teamList.slice(i, i + groupSize))
        }
        return teamGroups
    }

    updateTeamList(team){
        const teams = JSON.parse(JSON.stringify(this.teams))
        teams[team.id] = JSON.parse(JSON.stringify(team));
        this.teams = teams;
    }

    async deleteTeam(teamId, bewerbId){
        const reply = await FirebaseWrite.deleteTeamFromRunde(
            bewerbId, teamId,this.id
        )
        if ( reply.successful ) {
            this.teams = reply.content.teams
        }
    }

    isComplete(){
        const teams = Object.values(this.teams)
        return teams.filter(team => team.results.status === '' ||
                                    team.results.status === null ||
                                    (team.results.losEntscheid && !team.results.positionLos)).length === 0 &&
                  teams.length>0;
    }

    checkForDuplicatePlayers(team, isDouble) {
        const teams = Object.values(this.teams)
        const usedPlayers = new Map()
        for ( let i = 0; i < teams.length; i++ ) {
            const player1 = teams[i].settings?.player1?.id
            const player2 = teams[i].settings?.player2?.id
            if ( team.id !== teams[i].id ) {
                if ( player1 ) usedPlayers.set(player1, true)
                if ( player2 ) usedPlayers.set(player2, true)
            }
        }
        if ( !isDouble ) {
            if ( usedPlayers.get(team.settings.player1?.id) === true )
                return 'Diese Person wird in dieser Runde bereits verwendet. Bitte wähle eine andere Person aus.'
        } else {
            if ( usedPlayers.get(team.settings.player1?.id) === true ||
                usedPlayers.get(team.settings.player2?.id) === true )
                return 'Zumindest eine Person dieses Teams wird in dieser Runde bereits in einem anderen Team ' +
                    'verwendet. Bitte wähle eine andere Person aus.'
        }
        return ''
    }

    async fillFromPreviousRunde(previousRunde, copyUntilPosition, bewerbId){
        const previousTeams = Object.values(previousRunde.teams)
        const newTeamList = previousTeams.filter( (team) => team.results.position <= parseInt(copyUntilPosition) ).sort(
            (b,a) => a.results.position > b.results.position ? 1 : -1
        )
        const newTeams = {}
        for ( let i = 0; i < newTeamList.length; i++ ) {
            const team = JSON.parse(JSON.stringify(newTeamList[i]))
            team.results = {
                abraeumen: 0,
                fehlwuerfe: 0,
                gesamt: null,
                kommentar: '',
                losEntscheid: false,
                position: 1000,
                positionLos: null,
                status: '',
                volle: 0
            }
            team.id = i+1
            newTeams[team.id] = team
        }
        this.teams = newTeams
        // update in Bewerb
        return await FirebaseWrite.update('meisterschaftenBewerbe', bewerbId,
            {['runden.' + this.id + '.teams']: newTeams }
        )
    }

}